import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";
export default function ThumbsUp({ color = "offWhite" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M19.1668 8.33325C19.1668 7.89122 18.9912 7.4673 18.6787 7.15474C18.3661 6.84218 17.9422 6.66658 17.5002 6.66658H12.2335L13.0335 2.85825C13.0502 2.77492 13.0585 2.68325 13.0585 2.59158C13.0585 2.24992 12.9168 1.93325 12.6918 1.70825L11.8085 0.833252L6.32516 6.31658C6.01683 6.62492 5.8335 7.04158 5.8335 7.49992V15.8332C5.8335 16.2753 6.00909 16.6992 6.32165 17.0118C6.63421 17.3243 7.05814 17.4999 7.50016 17.4999H15.0002C15.6918 17.4999 16.2835 17.0833 16.5335 16.4832L19.0502 10.6082C19.1252 10.4166 19.1668 10.2166 19.1668 9.99992V8.33325ZM0.833496 17.4999H4.16683V7.49992H0.833496V17.4999Z"
        fill="#0068FF"
      />
    </svg>
  );
}
